import React, { useEffect, useState } from "react";
import { useAdminContext } from "../../Hooks/AdminContext";
import { enqueueSnackbar } from "notistack";
import {
  change_Status_OF_Sub,
  List_Sub_Req_Admin,
  Scree_Base_List,
} from "../../DAL/Listing/AgencyAddAcount";
import CustomTable from "../../components/customTable/CustomTable";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Button, Tooltip } from "@mui/material";
import { show_proper_words } from "../../utils/constant";
import StatusChip from "../../theme/chip";
import moment from "moment";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import SingleSelectAutocomplete from "../../components/AutoComplete/AutoComplete";
import CustomModal from "../../components/CustomModel";
import { useLocation } from "react-router-dom";
import { CancelSubscriptionDetails } from "./component/CancelSubscriptionDetails";

export const CancelSubscripiton = () => {
  const { setnavbarTitle, socket } = useAdminContext();
  const location = useLocation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  // const [rowDataID, setRowDataID] = useState("");
  const [rowData, setRowData] = useState({});
  const [employee, setEmployee] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [employeeArray, setEmployeeArray] = useState([]);
  const [modelState, setOpenModal] = useState(false);

  // This function handles the "Edit" action for a specific row in the table.
  // It sets the row data to be used in the modal and stores the row's ID.
  // Then it opens the modal for editing the selected item.
  const handleClickEdit = (row) => {
    setRowData(row);
    // setRowDataID(row._id);
    setOpenModal(true);
  };

  // This function handles the status change for a subscription request.
  // It sends the updated status to the backend, listens for a successful response,
  // and performs necessary actions like emitting a socket event, updating the UI,
  // and displaying a success or error message.
  const handleChangeStatus = async (status) => {
    const formData = {
      _id: rowData._id,
      employee_id: employee.id,
    };
    setLoadingButton(true);
    const response = await change_Status_OF_Sub(formData);
    if (response.code === 200) {
      socket.emit("cancel_subscription_event", {
        notification: response.notification,
      });
      setLoadingButton(false);
      handleCloseModel();
      getSubscriptionRequestList();
      enqueueSnackbar(response.message, { variant: "success" });
    } else {
      setLoadingButton(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  // This function is responsible for closing the modal and clearing the data.
  // It resets the row data, employee information, and modal visibility state.
  const handleCloseModel = () => {
    setRowData(null);
    // setRowDataID(null);
    setEmployee(null);
    setOpenModal(false);
  };

  // This function handles the change in the current page number for pagination.
  // It updates the `page` state and adjusts the `pageCount` depending on the new page number.
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  // This function updates the number of rows per page for pagination.
  // It resets the current page to 0 to reflect the updated page size.
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // This function handles changes in the page number, specifically ensuring it adjusts correctly for pagination.
  // It updates the `page` and `pageCount` based on the new page value.
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  // This function fetches the subscription request list from the server, updating the state with the response data.
  // It handles pagination and displays the appropriate subscription data based on the current page and rows per page.
  const getSubscriptionRequestList = async () => {
    setLoading(true);
    const response = await List_Sub_Req_Admin({}, page, rowsPerPage);
    if (response.code === 200) {
      setLoading(false);
      setList(response?.subscription);
      setTotalCount(response?.total_count);
      setTotalPages(response?.total_pages);
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, {
        variant: "error",
      });
    }
  };

  // The `User_Table_Head` is an array that defines the headers and rendering logic for the columns
  // in the user table, where each object represents a column in the table.
  const User_Table_Head = [
    {
      id: "action",
      label: "Action",
      renderData: (row) => (
        <>
          <Tooltip title="View Detail" placement="top">
            <RemoveRedEyeIcon
              onClick={() => {
                handleClickEdit(row);
              }}
              style={{ fill: "#fff", marginRight: "10px", cursor: "pointer" }}
            />
          </Tooltip>
        </>
      ),
    },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "user",
      label: "User",
      renderData: (row) => (
        <div
          className="pointer"
          onClick={() => {
            handleClickEdit(row);
          }}
        >
          <div>
            {show_proper_words(
              row?.user_info?.first_name + " " + row?.user_info?.last_name
            ) || "_ _"}
          </div>
          <div className="text-muted" style={{ fontSize: "0.9em" }}>
            {row?.user_info?.email || "_ _"}
          </div>
        </div>
      ),
    },
    {
      id: "product",
      label: "Subscription",
      renderData: (row) => (
        <div className="pointer">
          <div>{row?.product_info?.title || "_ _"}</div>
          <div className="text-muted">
            ${row?.product_info?.amount} / {row?.product_info?.interval_type}
          </div>
        </div>
      ),
    },
    {
      id: "platform",
      label: "Account Type",
      renderData: (row) => (
        <span className="pointer capitalized">
          {row?.product_info?.product_type || "s_ _"}
        </span>
      ),
    },
    // {
    //   label: "Subscription Mode",
    //   renderData: (row) => (
    //     <span className="text-capitalize">
    //       {row.subscription_mode || "_ _"}
    //     </span>
    //   ),
    // },
    {
      label: "Cancel Request Date",
      renderData: (row) =>
        row.cancel_request_date ? (
          <span>
            {moment(row.cancel_request_date).format("DD MMM YY hh:mm A")}
          </span>
        ) : (
          "_ _"
        ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip
          status={
            row.cancel_request === "pending"
              ? "Pending"
              : row.cancel_request === "canceled"
              ? "Canceled"
              : ""
          }
          type="activeInactive"
        />
      ),
    },
  ];

  // `handleGetDetailUser` is an asynchronous function that fetches user data based on a search value
  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "employee",
      search: value,
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setEmployeeArray(FormatData);
    }
  };

  // This hook runs when the `page`, `rowsPerPage`, or `location.state?.refresh` dependencies change.
  // It sets the navbar title to "Cancel Subscriptions" and fetches the updated subscription request list.
  useEffect(() => {
    setnavbarTitle("Cancel Subscriptions");
    getSubscriptionRequestList();
    handleGetDetailUser();
  }, [page, rowsPerPage, location.state?.refresh]);

  if (loading) {
    return <CustomCircularProgress />;
  }

  return (
    <div className="row mt-3">
      <div className="col-12">
        <CustomTable
          data={list}
          TABLE_HEAD={User_Table_Head}
          MENU_OPTIONS={[]}
          custom_pagination={{
            total_count: totalCount,
            rows_per_page: rowsPerPage,
            page: page,
            handleChangePage: handleChangePage,
            onRowsPerPageChange: handleChangeRowsPerPage,
          }}
          pageCount={pageCount}
          totalPages={totalPages}
          pagePagination={true}
          handleChangePages={handleChangePages}
          is_hide={true}
        />
      </div>
      <CustomModal
        crossButton={true}
        CustomSpacing={true}
        open={modelState}
        handleClose={handleCloseModel}
        component={
          <CancelSubscriptionDetails
            employee={employee}
            loadingButton={loadingButton}
            rowData={rowData}
            setEmployee={setEmployee}
            employeeArray={employeeArray}
            handleChangeStatus={handleChangeStatus}
          />
        }
      />
    </div>
  );
};
